export default "__VITE_PUBLIC_ASSET__10c1fce3__"